import * as React from 'react'

import { BlankSlate, Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { groupBy, map } from 'lodash'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type { IncidenceNotes } from 'modules/bookkeepers/store/collections/incidenceNotes'

import IncidenceNoteItem from './_IncidenceNoteItem'

interface Props {
  incidenceNotesCollection: IncidenceNotes
}

const incidenceGrouping = createComputed((collections: IncidenceNotes) => {
  if (!collections.length) return

  return groupBy(collections.models, (collection) => {
    const dateTime = stringToDate(collection.attributes.created_at, 'backend_datetime')

    return dateToString(dateTime, 'ui')
  })
})

const IncidenceNoteList = ({ incidenceNotesCollection }: Props) => {
  const incidenceNotes = incidenceGrouping(incidenceNotesCollection).get()

  return (
    <>
      <Text.Normal weight="semibold" size="300">
        {i18n.t('bookkeepers.incidence.note.title')}
      </Text.Normal>
      {incidenceNotes ? (
        <Box component="ul">
          {map(incidenceNotes, (notes, key) => (
            <Box key={key} component="li" gap="s16">
              <Box alignItems="center">
                <Tag type="grey">{key}</Tag>
              </Box>
              <Box component="ul" gap="s16">
                {notes.map((note) => (
                  <IncidenceNoteItem note={note} key={note.attributes.id} />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Box alignItems="center" justifyContent="center">
          <BlankSlate
            illustration="tasks_management"
            title={i18n.t('bookkeepers.incidence.note.blank_slate.title')}
            description={i18n.t('bookkeepers.incidence.note.blank_slate.description')}
          />
        </Box>
      )}
    </>
  )
}

export default observer(IncidenceNoteList)
